import styled from "styled-components";

export const CartCardStyled = styled.li`
  position: relative;
  display: flex;
  width: 100%;
  height: 8rem;
  gap: 1rem;

  & > img {
    height: 100%;
    object-fit: cover;
    background-color: var(--color-grey-20);
    border-radius: 0.5rem;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 1.2rem;
    padding: 0.3rem 0;

    & > div {
      width: 10.6rem;
      height: 3.4rem;
      background-color: #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0.5rem;

      & > span {
        background-color: var(--background);
        width: 50%;
        height: 80%;
        font-size: 1.2rem;
        color: black;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      & > button {
        border: none;
        background-color: transparent;
        width: 3rem;
        height: 3.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.2rem;
        color: var(--color-secondary);
        font-weight: 400;
        cursor: pointer;

        &:hover {
          opacity: 0.5;
        }
      }
    }
  }

  & > button {
    position: absolute;
    top: 1.7rem;
    right: 0;
    background-color: transparent;
    border: none;
    font-weight: 500;
    font-size: 1.4rem;
    color: var(--color-grey-50);
    cursor: pointer;
  }
`;
